export default function setLocationContainerData(data, showPanel, showWindow, marker) {
  const panel = document.querySelector('[data-module="CustomInfoPanel"]');
  const window = document.querySelector('[data-module="CustomInfoWindow"]');

  let module = null;

  if (showPanel) {
    module = panel;
  }
  if (showWindow) {
    module = window;
  }

  const fileExists = urlToFile => {
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();

    return xhr.status !== 404;
  };

  if (panel || window) {
    const pictureContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__PictureContainer"]'
    );
    const picture = module.querySelector('[data-child-module="LocatorInfowindow__Picture"]');
    const contactPersonContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__ContactPersonContainer"]'
    );
    const contactPersonName = module.querySelector(
      '[data-child-module="LocatorInfowindow__ContactPersonName"]'
    );
    const contactPersonImage = module.querySelector(
      '[data-child-module="LocatorInfowindow__ContactPersonImage"]'
    );
    const companyNameContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__CompanyNameContainer"]'
    );
    const companyName = module.querySelector(
      '[data-child-module="LocatorInfowindow__CompanyName"]'
    );
    const addressContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__AddressContainer"]'
    );
    const address = module.querySelector('[data-child-module="LocatorInfowindow__Address"]');
    const phoneNumberContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__PhoneNumberContainer"]'
    );
    const phoneNumber = module.querySelector(
      '[data-child-module="LocatorInfowindow__PhoneNumber"]'
    );
    const emailContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__EmailContainer"]'
    );
    const email = module.querySelector('[data-child-module="LocatorInfowindow__Email"]');
    const websiteContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__WebsiteContainer"]'
    );
    const website = module.querySelector('[data-child-module="LocatorInfowindow__Website"]');
    const routeContainer = module.querySelector(
      '[data-child-module="LocatorInfowindow__RouteContainer"]'
    );
    const route = module.querySelector('[data-child-module="LocatorInfowindow__Route"]');

    // picture
    if (data.Image !== null || data.Id !== null) {
      if (data.Image !== null) {
        const image = picture;
        image.src = `/content/map/${data.Image}?=`;

        if (fileExists(image.src)) {
          pictureContainer.removeAttribute('style');
        }
      }
    }

    // ContactPersonName
    if (data.ContactName !== null && data.ContactName.toLowerCase() !== 'null') {
      contactPersonName.innerHTML = `Tip from ${data.ContactName}`;
      contactPersonImage.src = `/media/${data.ContactName}.png?=`;

      if (fileExists(contactPersonImage.src)) {
        contactPersonContainer.removeAttribute('style');
      }
    } else {
      contactPersonContainer.style.display = 'none';
    }

    // Companyname
    if (data.CompanyName !== null) {
      companyName.innerHTML = data.CompanyName;
      companyNameContainer.removeAttribute('style');
    }

    // address
    address.innerHTML = '';
    let addressNumber = '';
    if (data.Street !== null) {
      if (data.HouseNumber !== null) {
        addressNumber = data.HouseNumber;
        if (
          data.HouseNumberAddition !== null &&
          data.HouseNumberAddition.toLowerCase() !== 'null'
        ) {
          addressNumber += data.HouseNumberAddition;
        }
      }

      address.innerHTML = `${data.Street} ${addressNumber}<br/>`;
      addressContainer.removeAttribute('style');
    }

    if (data.PostalCode !== null) {
      address.innerHTML += `${data.PostalCode}&nbsp;`;
      addressContainer.removeAttribute('style');
    }

    if (data.City !== null) {
      address.innerHTML += data.City;
      addressContainer.removeAttribute('style');
    }

    // phone
    phoneNumber.innerHTML = '';
    if (
      data.PhoneNumber !== null &&
      data.PhoneNumber.toLowerCase() !== 'null' &&
      data.PhoneNumber.toLowerCase() !== ''
    ) {
      phoneNumber.innerHTML = data.PhoneNumber;
      phoneNumber.href = `tel:${data.PhoneNumber.replaceAll(' ', '')}`;
      phoneNumberContainer.removeAttribute('style');
    }

    // email
    email.innerHTML = '';
    if (
      data.Email !== null &&
      data.Email.toLowerCase() !== 'null' &&
      data.Email.toLowerCase() !== ''
    ) {
      email.innerHTML = data.Email;
      email.href = `mailto:${data.Email.replaceAll(' ', '')}`;
      emailContainer.removeAttribute('style');
    }

    // website
    website.href = '';
    website.innerHTML = '';
    if (
      data.Website !== null &&
      data.Website.toLowerCase() !== 'null' &&
      data.Website.toLowerCase() !== ''
    ) {
      website.href = data.Website;
      website.innerHTML = data.Website;
      websiteContainer.removeAttribute('style');
    }

    // route
    route.href = '';
    if (
      data.Street !== null &&
      data.Street.toLowerCase() !== 'null' &&
      data.Street.toLowerCase() !== ''
    ) {
      const routeString = `${data.Street}+${data.PostalCode}+${data.City}`;
      route.href = `https://www.google.com/maps/dir/?api=1&destination=${routeString}`;
      routeContainer.removeAttribute('style');
    }
  }

  if (showPanel) {
    const buttonClose = module.querySelector('[data-child-module="LocatorGmapsTravel__Close"]');

    buttonClose.addEventListener('click', () => {
      module.style.display = 'none';
      const markerIconLocation = '/dist/images/icons/maps-marker-location.svg';
      marker.setIcon(markerIconLocation);
    });

    module.removeAttribute('style');
  }

  if (showWindow) {
    const cloneModule = window.cloneNode(true);
    cloneModule.removeAttribute('style');

    return cloneModule;
  }

  return panel;
}
